import { render, staticRenderFns } from "./Game5-2.vue?vue&type=template&id=80ebad6a&scoped=true&"
import script from "./Game5-2.vue?vue&type=script&lang=js&"
export * from "./Game5-2.vue?vue&type=script&lang=js&"
import style0 from "./Game5-2.vue?vue&type=style&index=0&id=80ebad6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ebad6a",
  null
  
)

export default component.exports